import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FakeData from '.././fake-data';
import { Modal, ComboBox, ConfirmModal } from './Common';
import './RichTextEditor.css';
import Remarkable from 'remarkable';

const Europa = window.Europa;

class RichTextEditor extends Component {
    constructor(p) {
        super(p)
        this.state = {
            data: this.props.content,
            isEditting: (this.props.isViewing) ? false : true,
            isViewing: (this.props.isViewing) ? true : false,
            textStyles: [
                {
                    size: "h1",
                    data: "<h1>Heading 1</h1>"
                },
                {
                    size: "h2",
                    data: "<h2>Heading 2</h2>"
                },
                {
                    size: "h3",
                    data: "<h3>Heading 3</h3>"
                },
                {
                    size: "h4",
                    data: "<h4>Heading 4</h4>"
                },
                {
                    size: "h5",
                    data: "<h5>Heading 5</h5>"
                },
                {
                    size: "h6",
                    data: "<h6>Heading 6</h6>"
                },
                {
                    size: "p",
                    data: "<p>Normal</p>"
                }
            ]
        }
    }

    componentDidMount() {
        this.europa = new Europa()
    }

    componentWillUnmount() {
        this.europa.release()
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.isViewing) {
            this.setState({ data: nextProps.content });
        }
    }


    format(command, args) {
        document.execCommand(command, false, args)
    }

    createLink() {
        var link = prompt("Enter your link here", "http://")
        document.execCommand("createLink", false, link)
    }

    removeLink() {
        document.execCommand("Unlink", false, null)
    }

    onSave() {
        const htmlString = this.elem.innerHTML;
        const markdown = this.europa.convert(htmlString);
        //console.log(htmlString)
        //console.log(markdown)
        this.props.onSave(markdown)
    }

    getImages() {

    }

    getRawData() {
        var md = new Remarkable();
        //console.log(md.render(this.state.data))
        return { __html: md.render(this.state.data) };
    }

    render() {
        const { isBasic } = this.props
        return (
            <div className={(this.state.isViewing) ? "sp-tx-editor view-mode" : "sp-tx-editor"}>
                {!this.state.isViewing &&
                    <div className="sp-tx-editor-toolbar">
                        <div className="sp-tx-editor-toolbar-split">
                            <div className="sp-tx-editor-toolbar-icon">
                                <i className="material-icons" onClick={() => {
                                    this.format("undo")
                                }}>undo</i>
                            </div>
                            <div className="sp-tx-editor-toolbar-icon">
                                <i className="material-icons" onClick={() => {
                                    this.format("redo")
                                }}>redo</i>
                            </div>
                        </div>
                        <div className="sp-tx-editor-toolbar-split">
                            <div className="sp-tx-editor-toolbar-icon">
                                <i className="material-icons" onClick={() => {
                                    this.format("bold")
                                }}>format_bold</i>
                            </div>
                            <div className="sp-tx-editor-toolbar-icon">
                                <i className="material-icons" onClick={() => {
                                    this.format("underline")
                                }}>format_underlined</i>
                            </div>
                            <div className="sp-tx-editor-toolbar-icon">
                                <i className="material-icons" onClick={() => {
                                    this.format("italic")
                                }}>format_italic</i>
                            </div>
                            {!isBasic &&
                                <div className="sp-tx-editor-toolbar-icon" tabIndex={0} ref={(ref) => this.styles = (ref === null) ? this.styles : ref}>
                                    <i className="material-icons" onClick={() => {
                                        this.format("increaseFontSize")
                                    }}>format_size</i>
                                    <div className="sp-icon-drop-dn">
                                        {
                                            this.state.textStyles.map((item, i) => {
                                                return (
                                                    <div key={i} dangerouslySetInnerHTML={{ __html: item.data }} onClick={() => {
                                                        this.format("formatBlock", item.size)
                                                        this.styles.blur()
                                                    }}></div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                        {!isBasic &&
                            <div className="sp-tx-editor-toolbar-split">
                                <div className="sp-tx-editor-toolbar-icon">
                                    <i className="material-icons" onClick={() => {
                                        this.format("formatblock", "blockquote")
                                    }}>format_quote</i>
                                </div>
                                <div className="sp-tx-editor-toolbar-icon">
                                    <i className="material-icons" onClick={() => {
                                        this.format("insertUnorderedList")
                                    }}>format_list_bulleted</i>
                                </div>
                                <div className="sp-tx-editor-toolbar-icon">
                                    <i className="material-icons" onClick={() => {
                                        this.format("insertOrderedList")
                                    }}>format_list_numbered</i>
                                </div>
                            </div>
                        }
                        {!isBasic &&
                            <div className="sp-tx-editor-toolbar-split">
                                <div className="sp-tx-editor-toolbar-icon">
                                    <i className="material-icons" onClick={() => {
                                        this.createLink()
                                    }}>insert_link</i>
                                </div>
                                <div className="sp-tx-editor-toolbar-icon">
                                    <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDIyIDI0Ij48cGF0aCBkPSJNNS44OCAxNy4wMjJsLTMuNDMgMy40M3EtLjEzNC4xMi0uMzA4LjEyLS4xNiAwLS4zMDgtLjEyLS4xMi0uMTM1LS4xMi0uMzF0LjEyLS4zMDdsMy40My0zLjQzcS4xMzMtLjEyLjMwNy0uMTJ0LjMxLjEycS4xMi4xMzUuMTIuMzF0LS4xMi4zMDd6bTIuMjYzLjU1djQuMjg1cTAgLjE4OC0uMTIuMzA4dC0uMzEuMTItLjMwNy0uMTItLjEyLS4zMDhWMTcuNTdxMC0uMTg3LjEyLS4zMDd0LjMwOC0uMTIuMzA4LjEyLjEyLjMwOHptLTMtM3EwIC4xODctLjEyLjMwN3QtLjMxLjEySC40M3EtLjE4OCAwLS4zMDgtLjEyVDAgMTQuNTd0LjEyLS4zMDcuMzA4LS4xMmg0LjI4NnEuMTg4IDAgLjMwOC4xMnQuMTIuMzA4em0xNi45MjggMS43MTRxMCAxLjYwNy0xLjEzNyAyLjcybC0xLjk3IDEuOTU0cS0xLjExIDEuMTEyLTIuNzE4IDEuMTEyLTEuNjIgMC0yLjczMi0xLjEzOEw5LjA0IDE2LjQ0N3EtLjI4LS4yOC0uNTYzLS43NWwzLjItLjI0IDMuNjU3IDMuNjdxLjM2Mi4zNi45MS4zNjd0LjkxMi0uMzU1bDEuOTctMS45NTZxLjM3NC0uMzc1LjM3NC0uODk3IDAtLjUzNi0uMzc1LS45MWwtMy42Ny0zLjY4NC4yNC0zLjJxLjQ3LjI4Ljc1LjU2Mmw0LjUgNC41cTEuMTI2IDEuMTUyIDEuMTI2IDIuNzMyek0xMy44MSA2LjU5bC0zLjIuMjRMNi45NSAzLjE2cS0uMzc0LS4zNzUtLjkxLS4zNzUtLjUyMiAwLS45MS4zNjJMMy4xNiA1LjEwMnEtLjM3NS4zNzUtLjM3NS44OTcgMCAuNTM1LjM3NS45MWwzLjY3IDMuNjctLjI0IDMuMjE0cS0uNDctLjI4LS43NS0uNTYzbC00LjUtNC41US4yMTMgNy41OC4yMTMgNnEwLTEuNjA4IDEuMTM4LTIuNzJsMS45Ny0xLjk1NVE0LjQzLjIxMyA2LjA0LjIxM3ExLjYyIDAgMi43MzIgMS4xMzhsNC40NzMgNC40ODhxLjI4LjI4LjU2My43NXptOC40NzggMS4xMjRxMCAuMTg4LS4xMi4zMDh0LS4zMS4xMmgtNC4yODVxLS4xODcgMC0uMzA3LS4xMnQtLjEyLS4zMDguMTItLjMwOC4zMDgtLjEyaDQuMjg3cS4xODggMCAuMzA4LjEydC4xMi4zMDh6TTE1IC40M3Y0LjI4NXEwIC4xODgtLjEyLjMwOHQtLjMxLjEyLS4zMDctLjEyLS4xMi0uMzA4Vi40M3EwLS4xOS4xMi0uMzFUMTQuNTcgMHQuMzEuMTIuMTIuMzF6bTUuNDUgMi4wMmwtMy40MjggMy40M3EtLjE0Ny4xMi0uMzA4LjEydC0uMzA4LS4xMnEtLjEyLS4xMzQtLjEyLS4zMDh0LjEyLS4zMDhsMy40My0zLjQzcS4xMzMtLjEyLjMwNy0uMTJ0LjMwOC4xMnEuMTIyLjEzNS4xMjIuMzF0LS4xMi4zMDd6Ii8+PC9zdmc+" className="material-icons" onClick={() => {
                                        this.removeLink()
                                    }} />
                                </div>
                                <div className="sp-tx-editor-toolbar-icon" onClick={() => this.setState({ isAddingIMG: true })}>
                                    <i className="material-icons">insert_photo</i>
                                </div>
                            </div>
                        }
                        <div className="sp-tx-editor-toolbar-split">
                            <div className="sp-tx-editor-toolbar-icon" onClick={() => this.setState({ isEditting: (this.state.isEditting) ? false : true })}>
                                <i className="material-icons">visibility</i>
                            </div>
                            <div className="sp-tx-editor-toolbar-icon">
                                <i className="material-icons" onClick={this.onSave.bind(this)}>save</i>
                            </div>

                        </div>
                    </div>
                }
                <div className="sp-tx-editor-body" ref={(ref) => this.elem = (ref === null) ? this.elem : ref} contentEditable={this.state.isEditting} dangerouslySetInnerHTML={this.getRawData()}>
                </div>
                <RTEAddImage pictures={(this.props.pictures) ? this.props.pictures : []} isOpen={this.state.isAddingIMG} onClose={(src) => {
                    this.format("insertImage", src)
                    this.setState({ isAddingIMG: false });
                }} />
            </div>
        )
    }
}

class RTEAddImage extends Component {
    constructor(p) {
        super(p)
        this.state = {
            media: {},
            file: {},
        }
    }

    onFilePicked(file) {
        const _that = this
        let reader = new FileReader()
        reader.onloadend = () => {
            const newFile = {
                file: file,
                progress: 0,
                url: reader.result
            }

            _that.setState({
                file: newFile
            });

            _that.uploadFile(newFile)
        }
        reader.readAsDataURL(file)
    }

    uploadFile(file) {
        var formdata = new FormData();
        const _that = this
        formdata.append("file", file.file);
        formdata.append("location", "");
        formdata.append("albumId", 0);
        formdata.append("tags", "")
        formdata.append("toId", FakeData.getData("yoo").id);
        var ajax = new XMLHttpRequest();
        ajax.upload.addEventListener("progress", (e) => {
            let percent = Math.round((e.loaded / e.total) * 100);
            _that.state.file.progress = percent
            _that.setState({
                file: _that.state.file
            });
        }, false);
        ajax.addEventListener("load", (e) => {
            let data = JSON.parse(e.target.responseText)
            data.oldUrl = file.url
            _that.setState({
                media: data
            });
            _that.onClose(data.url)
        }, false);
        ajax.open("POST", FakeData.URL + "/uploadMedia.php?auth0&userId=" + FakeData.getData("yoo").id);
        ajax.send(formdata);

    }

    onClose(url) {
        //TODO
        this.props.onClose(url)
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen} onClose={this.onClose.bind(this)}>
                <div className="add-place">
                    <div className="photos-to-add-btn">
                        <span>Upload File</span>
                        <input type="file" accept="image/*" onChange={(e) => this.onFilePicked(e.target.files[0])} />
                    </div>
                    <div className="photos-to-add">
                        {
                            this.props.pictures.map((item, i) => {
                                return (
                                    <div key={i} className="photos-to-add-item" onClick={() => this.onClose(item.url)}>
                                        <img src={item.url} />
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </Modal>
        )
    }
}

export default RichTextEditor;


// WEBPACK FOOTER //
// ./src/components/RichTextEditor.js